import { ENV } from '~/constants/env'
import { http } from '~/services/http'

const moonPayApiServer = 'https://api.moonpay.io'

export const getPublishableApiKey = () => {
  return ENV.production
    ? 'pk_live_vAZXyWuuqQXnA5Z5hSg0BnyDeTNdLFfx'
    : 'pk_test_ZosXdfzQO9YOrXv1gRta6Cdmh6mPt5m'
}

export const getCurrencies = () => {
  return http.get(`${moonPayApiServer}/v3/currencies`).then((res) => res.data)
}

export const getExchangeRate = (symbol, currentHost?: string) => {
  return http
    .get(
      `${moonPayApiServer}/v3/currencies/${symbol}/price?apiKey=${getPublishableApiKey()}`,
    )
    .then((res) => res.data)
}

let oriTime = Date.now()
let cachedCurrencies = null

export const getCachedCurrencies = async () => {
  // 缓存一小时
  if (Date.now() - oriTime < 60 * 60 * 1000 && cachedCurrencies) {
    return cachedCurrencies
  }
  cachedCurrencies = await getCurrencies()
  oriTime = Date.now()
  return cachedCurrencies
}
